import BaseComponent from "../../base/base_component";

let screenLockView = require('./view/screen_lock.html');
class ScreenLockComponent extends BaseComponent {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'ScreenLockComponent';

    /**
     * Root component selector.
     *
     * @type {string}
     * @private
     */
    _selector = 'cgp-screen-lock-component';

    /**
     *
     */
    init() {
        super.init();
    }


    /**
     *
     * @returns {AgeComponent}
     */
    start() {
        // Attach the template into the login component html document object.
        let bakedHTML = this.bake(screenLockView, {});

        this.setHTML(bakedHTML)

        return this;
    }

}
export default ScreenLockComponent;